// Tab-title unread badge — turns the browser tab into "(3) Event Name", the
// way Gmail / WhatsApp Web show unread counts.
//
// The router and event middleware set `document.title` to the event name on
// every navigation, so instead of fighting them we observe the <title> element
// and re-apply the "(n) " prefix whenever the base title changes. This keeps
// the badge sticky across route changes without touching router.js.

let currentCount = 0;
let baseTitle = typeof document !== 'undefined' ? document.title : '';
let observing = false;

const PREFIX_RE = /^\(\d+\)\s+/;

function stripPrefix(title) {
  return (title || '').replace(PREFIX_RE, '');
}

function render() {
  if (typeof document === 'undefined') return;
  const desired =
    currentCount > 0 ? `(${currentCount}) ${baseTitle}` : baseTitle;
  if (document.title !== desired) {
    // Guard the observer against reacting to our own write.
    suppressNext = true;
    document.title = desired;
  }
}

let suppressNext = false;

function ensureObserver() {
  if (observing || typeof document === 'undefined') return;
  const titleEl = document.querySelector('title');
  if (!titleEl || typeof MutationObserver === 'undefined') return;
  const observer = new MutationObserver(() => {
    if (suppressNext) {
      suppressNext = false;
      return;
    }
    // External (router) title change — adopt it as the new base, re-badge.
    baseTitle = stripPrefix(document.title);
    render();
  });
  observer.observe(titleEl, { childList: true });
  observing = true;
}

// Set the unread count shown in the tab title. Call whenever unread changes.
export function setTabBadge(count) {
  ensureObserver();
  currentCount = Number(count) || 0;
  // Re-read the base in case the title changed before the observer attached.
  baseTitle = stripPrefix(document.title);
  render();
}
